import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")!
  const _component_ion_app = _resolveComponent("ion-app")!

  return (_openBlock(), _createBlock(_component_ion_app, null, {
    default: _withCtx(() => [
      (_ctx.currentError)
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.errorComponent), { key: 0 }))
        : (_openBlock(), _createBlock(_component_ion_router_outlet, { key: 1 }))
    ]),
    _: 1
  }))
}